module.exports = __webpack_public_path__ + "img/sumary_ev_charger.2d9ebb22.svg";